import {
  AddMoreUserBtn,
  AddMoreUserBtnWrapper,
  GridElementFullWidth,
  MUICheckbox,
  ServicesCheckBoxList,
} from "../style";
import { POD_ONBOARDING } from "utility/constants";
import {
  FormControlLabel,
} from "@mui/material";
import { formLabelStyle } from "utility/styles";
import { useDispatch, useSelector } from "react-redux";
import { getPodList, getRoles } from "../ducks/selectors";
import { useEffect, useRef } from "react";
import { Step2FieldsInterface, Step3FieldsInterface } from "../ducks/types";
import AddUser from "./AddUser";
import { FieldErrors, UseFormRegister, UseFormSetError, UseFormSetValue } from "react-hook-form";

interface PodOnboardingStep3Props {
  register: UseFormRegister<{
    users?: {
        email?: string;
        roles: string[];
    }[];
    addUserLater?: boolean;
}>;
  fields: {
    email?: string;
    roles: string[];
}[] | undefined;
  errors: FieldErrors<Step2FieldsInterface>;
  removeUserHandler(index: number | Array< number>): () => void;
  addUser(arg: { email?: string; roles: string[] }): void;
  setStep3Error: UseFormSetError<Step3FieldsInterface>;
  clearStep3Errors: any;
  addUserHandler(): void;
  usersList: {email?: string, roles: string[]}[];
  updateUserList(arg: {
    email?: string;
    roles: string[];
  }[]): void;
  step3SetValue: UseFormSetValue<Step3FieldsInterface>;
  addUserLater?: boolean;
  isSubmitted?: boolean;
}

export const PodOnboardingStep3 = ({
  register,
  fields,
  errors,
  removeUserHandler,
  addUser,
  addUserHandler,
  usersList,
  updateUserList,
  step3SetValue,
  addUserLater,
  isSubmitted
}: PodOnboardingStep3Props) => {
  const dispatch = useDispatch();
  const isMounted = useRef(false);
  const roles = useSelector(getRoles);
  const podList = useSelector(getPodList);

  useEffect(() => {
    if (!isMounted.current && !addUserLater) {
      if (!fields || fields.length === 0) {
        addUser({ email: "", roles: [] });
      }
      isMounted.current = true;
    }
  }, [dispatch, roles, addUser, fields, addUserLater, podList]);

  const onChangeAddUserLater = (event: any) => {
    if(event.target.checked && fields) {
      updateUserList(fields);
      removeUserHandler(fields.map((_, index: number) => index))();
    } else {
      step3SetValue("users", usersList)
    }
  }

  const onClickAddUserBtn = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();
    addUserHandler();
  }
  return (
    <>
    <GridElementFullWidth>
      <FormControlLabel
        control={<MUICheckbox defaultChecked={addUserLater} {...register("addUserLater", {
          onChange: onChangeAddUserLater
        })} />}
        label={POD_ONBOARDING.ADD_USER_LATER}
        sx={formLabelStyle}
      />
      </GridElementFullWidth>
      <GridElementFullWidth>
      <ServicesCheckBoxList>
        {fields && fields.map((field, index) => (
          <AddUser key={field.email || index} field={field} errors={errors} removeUserHandler={removeUserHandler} index={index} register={register} setValue={step3SetValue} isSubmitted={isSubmitted} />
        ))}
      </ServicesCheckBoxList>
      {
        (fields && fields?.length <= 20 && fields?.length > 0) && <AddMoreUserBtnWrapper><AddMoreUserBtn onClick={onClickAddUserBtn}>Add more</AddMoreUserBtn></AddMoreUserBtnWrapper>
      }
    </GridElementFullWidth>
    </>
  );
};
